import React from "react";
import "./RegistrationLegalNotice.css";

const POPUP_NAME = "dakasa-legal-document";
const POPUP_FEATURES = "popup=yes,width=880,height=720,resizable=yes,scrollbars=yes";

function openLegalDocument(event: React.MouseEvent<HTMLAnchorElement>) {
  const popup = window.open(event.currentTarget.href, POPUP_NAME, POPUP_FEATURES);
  if (!popup) return;

  event.preventDefault();
  popup.opener = null;
  popup.focus();
}

export const RegistrationLegalNotice: React.FC<{
  context?: "request" | "verification";
}> = ({ context = "request" }) => (
  <p className="registrationLegalNotice" data-testid="registration-legal-notice">
    {context === "verification"
      ? "Antes de iniciar a verificação, leia nossos"
      : "Ao enviar esta solicitação, você declara que leu e concorda com nossos"}{" "}
    <a
      href="/termos"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir Termos de Uso em uma nova janela"
      onClick={openLegalDocument}
    >
      Termos de Uso
    </a>{" "}
    e nossa{" "}
    <a
      href="/privacidade"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir Política de Privacidade em uma nova janela"
      onClick={openLegalDocument}
    >
      Política de Privacidade
    </a>
    .
  </p>
);

export default RegistrationLegalNotice;
